module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "chapter-2"
    }
  }, [_c('h1', [_vm._v("Chapter 2")]), _vm._v(" "), _c('div', {
    staticClass: "section level2",
    attrs: {
      "id": "growing-up-bullied-and-afraid"
    }
  }, [_c('h2', [_vm._v("Growing Up Bullied and Afraid")]), _vm._v(" "), _c('p', [_vm._v("When I started school, I was wearing special equipment for my feet. If you look at me, you will see that my feet turn out and my mom says I wore braces, like Forest Gump to try to straighten my legs. I do not remember that, but I remember wearing dress shoes as opposed to tennis shoes like my peers. Either way, that was enough for the kids to have a reason to start picking on me and this soon turned into all-out bullying.")]), _vm._v(" "), _c('p', [_vm._v("Many of the kids were ‘friends’ outside of school and would even come to my house and play and come to my birthday parties, but they bullied me verbally and physically at school just because they wanted to boost their own ego and look big, bad and tough. As the years would go on, the bullying would get worse and there were many times I would cry myself to sleep at night. I never fought back in my younger years because my parents instilled in me that fighting was wrong, and I always felt that they would tan my hide if I fought back. This made me a perfect target, and many took advantage of it. So, I would fight like mad in my dreams and fantasies, of which my skills would have put the greatest martial artist in awe. I believe it is always better to make a friend than an enemy and violence is not the answer, but sometimes you have to take a stand. Little did I know then that I was developing my ‘verbal judo’ skills, which is also a big part to being not only a martial artist, but a ‘martial arts professional.’")]), _vm._v(" "), _c('p', [_vm._v("Bullying is an unfortunate case that happens everywhere. It was bad when I was a kid, and I owe my family values and moral values to the fact that I never lost it and did something I would regret today. Nowadays, all you hear is kids who go on killing sprees; I feel this is because of the fact that God has been taken out of the public-school systems. There is undeniable proof that shows that bullying and other acts of violence have increased since God has been taken out of schools. That is why I am adding the following, current 2013 statistics of bullying:")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "left"
    }
  }, [_c('p', {
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("-")])]), _c('div', {
    staticStyle: {
      "padding-left": "45px"
    }
  }, [_c('p', [_vm._v("1 in 7 students from kindergarten to grade 12 has been a bully or has been bullied.")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "left"
    }
  }, [_c('p', {
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("-")])]), _c('div', {
    staticStyle: {
      "padding-left": "45px"
    }
  }, [_c('p', [_vm._v("61% of students who were interviewed stated that bullying can resort to students shooting other children.")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "left"
    }
  }, [_c('p', {
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("-")])]), _c('div', {
    staticStyle: {
      "padding-left": "45px"
    }
  }, [_c('p', [_vm._v("More than 56% of students had already witnessed bullying that happened while they were in school.")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "left"
    }
  }, [_c('p', {
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("-")])]), _c('div', {
    staticStyle: {
      "padding-left": "45px"
    }
  }, [_c('p', [_vm._v("71% of students reported that bullying is an on-going problem.")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "left"
    }
  }, [_c('p', {
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("-")])]), _c('div', {
    staticStyle: {
      "padding-left": "45px"
    }
  }, [_c('p', [_vm._v("1 in every 20 students has seen a student carrying a gun while in school premises.")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "left"
    }
  }, [_c('p', {
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("-")])]), _c('div', {
    staticStyle: {
      "padding-left": "45px"
    }
  }, [_c('p', [_vm._v("Top years for bullying are from 4"), _c('sup', [_vm._v("th")]), _vm._v("–8"), _c('sup', [_vm._v("th")]), _vm._v(" Grades.")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "left"
    }
  }, [_c('p', {
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("-")])]), _c('div', {
    staticStyle: {
      "padding-left": "45px"
    }
  }, [_c('p', [_vm._v("54% of students who witness violence and physical abuse at home can become bullies in schools.")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "left"
    }
  }, [_c('p', {
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("-")])]), _c('div', {
    staticStyle: {
      "padding-left": "45px"
    }
  }, [_c('p', [_vm._v("Each month, a shocking number of around 282,000 students are being victimized by bullying in the US.")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "left"
    }
  }, [_c('p', {
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("-")])]), _c('div', {
    staticStyle: {
      "padding-left": "45px"
    }
  }, [_c('p', [_vm._v("90% of victims admitted that they suffered negative side effects. Among them are:")])]), _vm._v(" "), _c('ol', {
    staticStyle: {
      "list-style-type": "decimal"
    }
  }, [_c('li', [_c('p', [_vm._v("Significant drop in grades")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("Increase in anxiety")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("Loss of friends")])]), _vm._v(" "), _c('li', [_c('p', [_vm._v("Loss of social life")])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "left"
    }
  }, [_c('p', {
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("-")])]), _c('div', {
    staticStyle: {
      "padding-left": "45px"
    }
  }, [_c('p', [_vm._v("27% of students have been victimized by school bullying because they are not sexually active.")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "left"
    }
  }, [_c('p', {
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("-")])]), _c('div', {
    staticStyle: {
      "padding-left": "45px"
    }
  }, [_c('p', [_vm._v("23% of students who are in grade 9 already carry a gun.")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v("About 77% of all students being bullied verbally, in some way or another, include mental bullying or even verbal abuse. These types of bullying can also include spreading rumors, yelling obscenities or other derogatory terms based on an individual’s race, gender, sexual orientation, religion, etc. Out of the 77% of those bullied, 14% have a severe or bad reaction to the abuse, according to recent school bullying statistics. These numbers make up the students that experience poor self-esteem, depression, anxiety about going to school and even suicidal thoughts (bullycide) as a result of being bullied by their peers. Also, as part of this study, about one in five students admitted they are responsible for bullying their peers. Almost ½ of all students fear harassment or bullying in the bathroom at school. As a result of this fear and anxiety of being bullied, many students will make excuses or find ways around going to school. School bullying statistics also reveal that teens’ ages 12–17 believe they have seen violence increase at their schools. In fact, these numbers also show that most violent altercations between students are more likely to occur on school grounds than on the way to school for many teens.")]), _vm._v(" "), _c('p', [_vm._v("One of the most unfortunate parts of these school bullying statistics, is that in about 85% of bullying cases, no intervention or effort is made by a teacher or administration member of the school to stop the bullying from taking place.")]), _vm._v(" "), _c('p', [_vm._v("Cyberbullying has become one of the most prevalent types of bullying that occurs between teens. About 80% of all high school students have encountered being bullied in some fashion online. These growing numbers are being attributed to youth violence including both homicide and suicide. While school shootings across the country are becoming more and more common, most teens that say they have considered becoming violent toward their peers, wish to do so because they want to get back at those who have bullied them online. About 35% of teens have been actually threatened online. About half of all teens admit they have said something mean or hurtful to another teen online. Most have done it more than once. I thank God we never had bullying like this when I was growing up, because I honestly don’t know how I would have handled it. Close to ½ of all children will experience school bullying at some point while they are at primary or secondary school. At least 10% of children are bullied regularly.")]), _vm._v(" "), _c('p', [_vm._v("Many parents are concerned that their child might be a victim of a child bullying. Some of the signs that a child is being bullied include:")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "left"
    }
  }, [_c('p', {
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("-")])]), _c('div', {
    staticStyle: {
      "padding-left": "45px"
    }
  }, [_c('p', [_vm._v("Becoming withdrawn")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "left"
    }
  }, [_c('p', {
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("-")])]), _c('div', {
    staticStyle: {
      "padding-left": "45px"
    }
  }, [_c('p', [_vm._v("Showing fear when it is time to go to school")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "left"
    }
  }, [_c('p', {
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("-")])]), _c('div', {
    staticStyle: {
      "padding-left": "45px"
    }
  }, [_c('p', [_vm._v("Increasing signs of depression")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "left"
    }
  }, [_c('p', {
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("-")])]), _c('div', {
    staticStyle: {
      "padding-left": "45px"
    }
  }, [_c('p', [_vm._v("Decline in school performance")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "left"
    }
  }, [_c('p', {
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("-")])]), _c('div', {
    staticStyle: {
      "padding-left": "45px"
    }
  }, [_c('p', [_vm._v("Speaking of another child with fear")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "left"
    }
  }, [_c('p', {
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("-")])]), _c('div', {
    staticStyle: {
      "padding-left": "45px"
    }
  }, [_c('p', [_vm._v("Noticeable decline in how the child sees him or herself")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "left"
    }
  }, [_c('p', {
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("-")])]), _c('div', {
    staticStyle: {
      "padding-left": "45px"
    }
  }, [_c('p', [_vm._v("A sign of physical altercations, such as bruises, scrapes and other marks")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v("It may be more difficult to spot signs of verbal or emotional bullying, but you should be on the lookout for indications that your child’s self-esteem and self-image are faltering, as well as a reluctance to go to school.")]), _vm._v(" "), _c('p', [_vm._v("You should also be on the alert for signs that your child is a bully. Child bullying behavior can be a precursor to problems later in life, especially criminal activity. It can also affect future professional and personal relationships. It is important that children learn to express themselves in socially acceptable ways, and bullying is not something that most in society tolerate. Here are some signs that your child might be a bully:")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "left"
    }
  }, [_c('p', {
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("-")])]), _c('div', {
    staticStyle: {
      "padding-left": "45px"
    }
  }, [_c('p', [_vm._v("Views violence positively as the solution to most problems")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "left"
    }
  }, [_c('p', {
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("-")])]), _c('div', {
    staticStyle: {
      "padding-left": "45px"
    }
  }, [_c('p', [_vm._v("Shows aggression toward adults as well as other children")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "left"
    }
  }, [_c('p', {
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("-")])]), _c('div', {
    staticStyle: {
      "padding-left": "45px"
    }
  }, [_c('p', [_vm._v("Need to dominate others and control situations")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "left"
    }
  }, [_c('p', {
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("-")])]), _c('div', {
    staticStyle: {
      "padding-left": "45px"
    }
  }, [_c('p', [_vm._v("Easily frustrated")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "left"
    }
  }, [_c('p', {
    staticStyle: {
      "text-indent": "1em"
    }
  }, [_vm._v("-")])]), _c('div', {
    staticStyle: {
      "padding-left": "45px"
    }
  }, [_c('p', [_vm._v("Shows little sympathy to others who are being bullied or who are having problems")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v("As you can see, the statistics of bullying are quite troubling, and I hope you can see why I am so passionate about doing public speaking about bullying and teaching self-defense to all who want to learn. As you have read, one troubling statistic is the fact that 85% of school officials look the other way. This was my case in many instances and several times I was the one who would get punished.")]), _vm._v(" "), _c('p', [_vm._v("When I was in the 5"), _c('sup', [_vm._v("th")]), _vm._v(" grade, I had enough and finally accepted a fight with a fellow student. I looked just like Ralph Macchio in the scene of ‘"), _c('em', [_vm._v("The Karate Kid’")]), _vm._v(" movie where he is practicing karate in his apartment by the way of a book. I did the same, I got my karate book and practiced like crazy for a couple days, and then the day came to get off the bus and fight. I was only a few blocks from my Grandparent’s house, and I even thought about staying on the bus and get off at the next stop. But I knew that I had to take a stand, so I got off the bus and met him face to face. We were surrounded by several of our classmates, and one crouched down behind me. The plan was that the bully would push me, and I would fall over the other boy. Little did he know that my plan was to ’strike first, strike hard,’ like the cobra kai motto of ‘"), _c('em', [_vm._v("The Karate Kid")]), _vm._v(".’ So, I did, and he went down hard! Because I was not properly trained, my balance and stance were off and I fell over the kid behind me, but I immediately jumped back to my feet. I accomplished what I wanted, and I ran towards my grandmother’s as fast as I could. Another boy caught and held me while the bully began punching me in the stomach. I think he decided to stop and leave because either he was tired, or he saw that the punches were not affecting me because I had so much adrenaline. Either way, that was the only time the bully and I squared off, and eventually we would become friends. I am now happy with what he has become and admire the life he has with his loving wife and children; he has become a good man.")]), _vm._v(" "), _c('p', [_vm._v("When I was in the 5"), _c('sup', [_vm._v("th")]), _vm._v(" grade, I met several boys who were in Jr. high and high school. Their names were the Hall brothers and Gary Gordon. As time went on, I would be riding my bike and they would try to run me off the road with their truck. One day however, they did more than that. After I avoided their truck and rode my bike into someone’s yard, Gary stuck his head out of the window, pointed a high caliber bb gun at me, and pulled the trigger. After a few seconds, I felt a searing pain in my left leg as blood began to trickle down it and Gary and the Hall brothers sped away in their truck. I screamed so loud that my father heard me a block away.")]), _vm._v(" "), _c('p', [_vm._v("My dad helped me into his pickup and broke just about every speed limit to the hospital. The doctor said I was lucky, as if the bb would have been a little lower, it would have gotten my main artery and I would have lost a great deal of blood, or worse. He also said he could not stitch it because the tear was too bad, so he could just bandage it. As we were leaving, the boys arrived at the hospital and approached me and my dad to say they were sorry. Not because they were, but because the police department ordered them too. My father slammed Gary, who was in the 8"), _c('sup', [_vm._v("th")]), _vm._v(" grade at that time, against the truck.")]), _vm._v(" "), _c('p', [_vm._v("Gary quickly screamed, “You can’t hurt me man, I am a juvenile!”")]), _vm._v(" "), _c('p', [_vm._v("My father said something like, “You are lucky, that is the only reason why I’m not going to beat you to a pulp.”")]), _vm._v(" "), _c('p', [_vm._v("And then we walked back to the truck.")]), _vm._v(" "), _c('p', [_vm._v("That day the Halls and Gary were all interviewed by the police, but I was never contacted. My family and I became furious; not only did we go to the local paper, we went to several papers throughout the State of Kansas. They all wrote an article about what happened to me and the incompetence of the Larned Police Department and how they looked the other way rather than coming to me, the victim. The end result, the Larned paper fired Gary as he was a paper boy, and they did not even know he was involved at that time. Also, I was finally interviewed by a police detective (three months after I was shot), and the three officers who should have interviewed me were given the chance to quit or be fired.")]), _vm._v(" "), _c('p', [_vm._v("About 10–15 years later, I saw Gary and he recognized me. He approached me and sincerely apologized for what he and his friends did to me. And then a few years after that, we worked together, and I now consider him a close friend. What had happened was in the past and long forgotten, but yet Gary felt compelled to say something years later. It takes a big man to admit they are wrong, and an even bigger man to ask for forgiveness. For that, Gary has my respect.")]), _vm._v(" "), _c('p', [_vm._v("A couple weeks ago, my friend, Jessica Hickman, texted me and asked if I would post something about bullying on her Facebook page and mine. Jessica is the Goddaughter and highest-ranking female student of former Ultimate Fighting Champion, Royce Gracie. Leanne, a 13-year-old daughter of a very close friend of hers, came to speak to her about being bullied. Jessica visited with her for a few hours and felt that she had reassured Leanne that things would get better.")]), _vm._v(" "), _c('p', [_vm._v("The next day, Jessica was notified that Leanne had taken her life. This troubles me greatly as this is a growing trend where bullying is concerned. Either the person being bullied gets to the point where they can no longer cope, or they commit suicide or ‘bullycide’ as it is called, or they go on a killing rampage as an act of revenge.")]), _vm._v(" "), _c('p', [_vm._v("I have heard many people say, “Kids these days just aren’t as tough as we were, they need to suck it up and just deal with it.”")]), _vm._v(" "), _c('p', [_vm._v("Well in my opinion, they are saying that because I feel they were once a bully themselves and thus are not empathizing with the people being bullied. Either way, bullying is wrong. That is why I have decided to run a nationwide campaign; to have harsh laws put into place as a deterrent directed towards all types bullying, from physical to cyber. I also feel that people in power, such as school officials who are aware of bullying and yet do nothing about it, should have some sort of ramification put into effect as well. As I mentioned earlier, in 85% of bullying cases, no intervention or effort is made by a teacher or administration member of the school to stop the bullying from taking place. This needs to change! Because of this, I wrote a letter to President Obama asking for laws to be instilled.")]), _vm._v(" "), _c('p', [_vm._v("Not only do I hope to have these laws put into effect nationwide, but it is also my hope that the world will adopt such laws and it will become an international campaign to end bullying. I am planning to call the law ‘The Leanne Law,’ in honor of my friend Jessica and the loss of her young friend Leanne. I also created a Facebook page where people can learn about statistics, give advice, tell stories and ask for help; in just a few weeks it already has 300 followers. It is:")]), _c('br'), _vm._v(" "), _c('p', [_vm._v("www.facebook.com/BullyingStopsHereTodayAmerica")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a2cea7c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch007.vue
// module id = 81
// module chunks = 0